'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'balloons';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e2e4';
var svgPathData = 'M320 160C320 71.6 248.4 0 160 0S0 71.6 0 160C0 272 128 368 128 368l-32 80 128 0-32-80s128-96 128-208zM160 96c-35.3 0-64 28.7-64 64l-48 0C48 98.1 98.1 48 160 48l0 48zM384 432l-32 80 128 0-32-80s128-96 128-208c0-88.4-71.6-160-160-160-23.1 0-45.1 4.9-64.9 13.7 6.3 14.7 11 30.3 13.9 46.6 15.3-7.9 32.7-12.3 51.1-12.3l0 48c-19.9 0-37.6 9.1-49.4 23.3-7.3 62.4-42.3 115.8-72.6 152.1 37.7 57.5 90 96.7 90 96.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBalloons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;